import React from 'react'
import Button from 'app/protected/common/components/Button'
import PropTypes from 'prop-types'
import i18next from 'i18next'

// Maps the legacy Semantic color names to the native Button variants.
const variantFor = (color) => (color === 'red' ? 'danger' : 'primary')

function ModalActions(props) {
  const { actionDisabled, action, actionText, actionColor, onCancel, cancelText, leftColor, leftText, leftAction } = props
  return (
    <div className="px-6 pt-4 pb-2.5">
      <div className="flex flex-1 items-stretch gap-3">
        {onCancel && (
          <div
            className="inline-flex items-center cursor-pointer font-nunito"
            onClick={onCancel}
          >
            {cancelText ? cancelText : i18next.t('cancel')}
          </div>
        )}
        {leftAction && (
          <Button variant={variantFor(leftColor)} disabled={actionDisabled} onClick={leftAction}>
            {leftText ? leftText : i18next.t('cancel')}
          </Button>
        )}
        <div className="flex flex-1 justify-end">
          <Button variant={variantFor(actionColor)} disabled={actionDisabled} onClick={action}>
            {actionText ? actionText : i18next.t('ok')}
          </Button>
        </div>
      </div>
    </div>
  )
}

ModalActions.propTypes = {
  actionDisabled: PropTypes.bool,
  action: PropTypes.func.isRequired,
  actionText: PropTypes.string,
  actionColor: PropTypes.string,
  onCancel: PropTypes.func,
  cancelText: PropTypes.string,
  leftColor: PropTypes.string,
  leftText: PropTypes.string,
  leftAction: PropTypes.func,
}

export default ModalActions
